import { Box, Button, Card, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useRef } from "react";
import Logo from "../assets/images/HeaderLogo.jpeg";

const LetterHead = () => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          mx: 4,
          mt: 1,
        }}
      >
        {" "}
        <Box sx={{ flex: 1 }}>
          <img src={Logo} alt="company-logo" height="25px" />
        </Box>
        <Box sx={{ marginRight: 0, maxWidth: 600 }}>
          <Typography variant="h4" color="primary">
            Optima Jobs
          </Typography>
          <Typography sx={{ fontSize: "11px" }}>
            <b>Address:</b>Kolhapur
            <br />
            <b>Mobile No.:</b> +91-9923968262,+91-9960480227, +91-7559272207
          </Typography>
        </Box>
      </Box>
      <Divider
        sx={{ borderBottomWidth: 1, mt: 1, mb: 2, bgcolor: "#000000" }}
      />
    </Box>
  );
};

export default LetterHead;
